import React from 'react';
import { PageSplitHorizontal, TimeseriesChartItem } from '@ihsm/ui-shared';
import { DetailsChartSegment } from '../DetailsChartSegment/DetailsChartSegment';
import { TableSegment } from '../TableSegment/TableSegment';

export interface GridAndChartWrapperProps {
  isSearchTreeCollapsed: boolean;
  chartData: TimeseriesChartItem[];
  isSideBarCollapsed: boolean;
  isTableVisible: boolean;
  isTimeseriesVisible: boolean;
}

export const GridAndChartWrapper: React.FC<GridAndChartWrapperProps> = ({
  isSearchTreeCollapsed,
  chartData,
  isSideBarCollapsed,
  isTableVisible,
  isTimeseriesVisible,
}): JSX.Element => {
  if (isTimeseriesVisible && isTableVisible) {
    return (
      <PageSplitHorizontal
        top={
          <DetailsChartSegment
            chartData={chartData}
            isSearchTreeCollapsed={isSearchTreeCollapsed}
            isSideBarCollapsed={isSideBarCollapsed}
          />
        }
        bottom={<TableSegment chartData={chartData} />}
        initialSize={600}
      />
    );
  }

  if (isTimeseriesVisible) {
    return (
      <DetailsChartSegment
        chartData={chartData}
        isSearchTreeCollapsed={isSearchTreeCollapsed}
        isSideBarCollapsed={isSideBarCollapsed}
      />
    );
  }

  if (isTableVisible) {
    return <TableSegment chartData={chartData} />;
  }

  return <></>;
};
